import React, { FCC } from 'react'

import { BillingInfoTable as StyledBillingInfoTable } from './BillingInfoTable.styles'

const BillingInfoTable: FCC = ({ children }) => (
  <StyledBillingInfoTable>
    <tbody>{children}</tbody>
  </StyledBillingInfoTable>
)

export default BillingInfoTable
